<template>
  <v-overlay :absolute="true" opacity="0.35" v-if="loading">
    <lottie :options="lottieOptions" :height="250" :width="250"/>
  </v-overlay>
</template>

<script>
import * as animationData from "@/assets/animations/loading.json";

export default {
  name: "LoadingOverlay",
  props: {
    loading: Boolean,
  },
  data() {
    return {
      lottieOptions: { animationData: animationData.default },
    };
  }
}
</script>